module.exports = "form .department-form-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n  form .department-form-header mat-input-container {\n    width: calc(100% - 120px); }\n  form .department-form-checkbox {\n  margin-left: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/departments/department-form/department-form.component.scss
// module id = ./libs/atenea-cms-brand/src/departments/department-form/department-form.component.scss
// module chunks = main